module.exports = __webpack_public_path__ + "img/img_5.842f18ba.png";